module.exports = __webpack_public_path__ + "img/2021_10_dande_koushouji_fin_web.4c8a242d.png";